import {HTTP} from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = 'Entity';

const entityStore = {
    namespaced: true,
    state:{
        totalItem:0,
        q : {
            tableNeedQuery: tableName,
            isOuterJoin: false,       
            searchCriteria: "",
            orderBy: "EntityNumber,asc",
            take: 1000000,
            skip: 0
        },
        currentSelectedPage: 0,
    },
    actions:{
        getAllEntity({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/qgl/listvalue', state.q).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getEntityACModel({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/entity/GetEntityACModel', {'entityNum':param.entityNum}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getEntityModel({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/entity/GetEntity', {'entityNum':param.entityNum}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getPDCheque({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/entity/ARPDChq', {'EntNum':param.EntNum}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getEntityGroupCrRef({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/entity/EntityGroupCrRef', {'EntNum':param.EntNum}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getEntityDocLib({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/entity/EntityDocLib', {'EntNum':param.EntNum}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        exportEntity({commit, state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/entity/ExportEntity', {'frEnt': param.frEnt, 'toEnt': param.toEnt}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            })
        },
        exportEntityLoc({commit, state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/entity/ExportEntityLoc', {'frEnt': param.frEnt, 'toEnt': param.toEnt}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            })
        },
    }
};
export default entityStore;